import { useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import { getGrayInfo } from '@/services/grayInfo';
import { GrayInfo } from '@/interface/gray';

export default () => {
  const [grayInfo, setGrayInfo] = useState<GrayInfo>();

  const googleServiceFeeGrayScale = useMemo(() => grayInfo?.google_service_fee, [grayInfo]);

  const { loading, run: getGrayInfoRequest } = useRequest(getGrayInfo, {
    manual: true,
    onSuccess(res) {
      setGrayInfo(res.data || {});
    },
    onError() {
      setGrayInfo(undefined);
    },
  });

  return {
    /** 是否正在加载灰度信息中 */
    loading,
    /** 灰度信息 */
    grayInfo,
    /** 谷歌服务费灰度 */
    googleServiceFeeGrayScale,
    /** 获取灰度信息
     *
     * 注意: 这是一个同步方法, 不能在函数组件中直接调用
     *
     * 你应该在 useEffect 或者 事件函数中调用
     */
    getGrayInfoRequest,
  };
};
